module.exports = __webpack_public_path__ + "static/img/1692694670693.524cb89b.jpg";